import useBedbankRateTierProgression from 'loyalty/hooks/useBedbankRateTierProgression'
import useUserTierProgress from 'loyalty/hooks/useUserTierProgress'
import withMountGuard from 'hocs/withMountGuard'
import { useAppSelector } from 'hooks/reduxHooks'
import getIsCurrentRegionUserLoyaltyRegion from 'loyalty/selectors/getIsCurrentRegionUserLoyaltyRegion'
import TierProgressionBanner from './TierProgressionBanner'
import { OptimizelyExperiments } from 'constants/optimizely'
import useExperiment from 'hooks/Optimizely/useExperiment'

interface Props {
  className?: string
  offer: App.BedbankOffer | undefined
  rates: Array<App.BedbankRate>
  nights: number
  checkoutDate?: string
}

function BedbankTierProgressionPanel({ className, offer, rates, nights, checkoutDate }: Props) {
  const {
    showTierProgressionBanner,
    lowestUnlockableTier,
    lowestUnlockableTierName,
    highestUnlockableTier,
    highestUnlockableTierName,
    hasMultipleTierJumps,
    isLoading,
    membershipYearEndDate,
  } = useBedbankRateTierProgression({
    offer,
    rates,
    nights,
    checkoutDate,
    skip: rates.length === 0 || nights <= 0,
  })

  const canActivateTierProgressionExperiment = showTierProgressionBanner && !isLoading
  const { isAnyVariant: isTierProgressionExperimentVariant } = useExperiment(
    OptimizelyExperiments.croTierProgressionOfferPage,
    { canActivate: canActivateTierProgressionExperiment },
  )

  const { creditsNeeded, nightsNeeded } = useUserTierProgress()

  if (!canActivateTierProgressionExperiment || !isTierProgressionExperimentVariant || isLoading || !showTierProgressionBanner) {
    return null
  }

  return (
    <TierProgressionBanner
      className={className}
      lowestUnlockableTier={lowestUnlockableTier}
      lowestUnlockableTierName={lowestUnlockableTierName}
      highestUnlockableTier={highestUnlockableTier}
      highestUnlockableTierName={highestUnlockableTierName}
      hasMultipleTierJumps={hasMultipleTierJumps}
      statusCreditsNeeded={creditsNeeded}
      nightsNeeded={nightsNeeded}
      membershipYearEndDate={membershipYearEndDate}
      checkoutDate={checkoutDate}
    />
  )
}

export default withMountGuard(() => {
  return useAppSelector(getIsCurrentRegionUserLoyaltyRegion)
})(BedbankTierProgressionPanel)
